<template>
  <div>
    <div v-if="charts.length > 0">
      <vue-apex-charts
        v-for="chart in charts"
        :key="chart.id"
        height="100"
        type="bar"
        class="mt-4 md:mt-1"
        :options="chart.options"
        :series="chart.series"
      />
    </div>
    <div v-else class="mt-4 flex w-full flex-col">
      <div class="flex flex-col items-center bg-white text-muted-foreground">
        <div placeholder-animation class="relative h-40 w-40 overflow-hidden">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="m-auto h-40 w-40"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M16 8v8m-4-5v5m-4-2v2m-2 4h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
            />
          </svg>
        </div>
        <div class="flex flex-col justify-between">
          {{ $t('global.loading.chart') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueApexCharts from 'vue3-apexcharts'
export default {
  components: {
    VueApexCharts
  },
  props: {
    chartId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      charts: [],
      questionText: ''
    }
  },
  created() {
    this.axios.get(`/surveys/${this.chartId}`).then((response) => {
      this.questionText = response.data.data.questionText
      const choices = response.data.data.choices

      this.axios.get(`/surveys/${this.chartId}/stats`).then((response) => {
        this.surveyedQuantity = response.data.data.surveyedQuantity
        this.answeredQuantity = response.data.data.answeredQuantity

        const answerTranslation = this.$t('pages.survey.surveyPage.charts.answerers')
        const colors = [
          {
            from: '#fcc419',
            to: '#f6c636'
          },
          {
            from: '#ff9369',
            to: '#ff92a0'
          },
          {
            from: '#49a3ff',
            to: '#56a8fb'
          },
          {
            from: '#4cb8c4',
            to: '#3cd3ad'
          },
          {
            from: '#ba7ddd',
            to: '#af6dd5'
          }
        ]

        response.data.data.results.forEach((choice, i) => {
          const answersPercentage =
            this.answeredQuantity > 0 ? Math.round((choice.count / this.answeredQuantity) * 100 * 100) / 100 : 0

          this.charts.push({
            options: {
              chart: {
                height: 10,
                type: 'bar',
                stacked: true,
                sparkline: {
                  enabled: true
                }
              },
              colors: [colors[i % colors.length].from],
              plotOptions: {
                bar: {
                  horizontal: true,
                  barHeight: '30%',
                  borderRadius: 0
                }
              },
              title: {
                floating: true,
                offsetX: -10,
                offsetY: 0,
                text: choices.filter((surveyChoice) => surveyChoice.id == choice.choiceId)[0].text
              },
              subtitle: {
                floating: true,
                align: 'right',
                offsetY: 0,
                offsetX: 10,
                text: `${answersPercentage}% (${choice.count} ${answerTranslation})`,
                style: {
                  color: colors[i % colors.length].to,
                  fontSize: '16px'
                }
              },
              tooltip: {
                enabled: false
              },
              yaxis: {
                max: 100
              },
              fill: {
                type: 'gradient',
                gradient: {
                  inverseColors: false,
                  gradientToColors: [colors[i % colors.length].to]
                }
              }
            },
            series: [
              {
                data: [answersPercentage]
              }
            ]
          })
        })
      })
    })
  }
}
</script>

<style>
@keyframes load {
  0% {
    left: -100%;
  }
  100% {
    left: 150%;
  }
}
</style>
